<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">状态</div>
          <div class="field">
            <el-select v-model="query.status" :clearable="true" placeholder="请选择">
              <el-option
                v-for="item in projectStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols"
            :showfooter="false" :showPage="true" :resizable="true"
            :total="query.total" @cellClick="cellClick"  @cellDblClick="viewProject" @pagechange="pagechange"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'psuBzjReturnIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        btnLoading: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'projectcode', fieldtype: 'C', title: '项目编号',calculExpr:'',addNewRowFlg: false},
          { field: 'projectname', fieldtype: 'C', title: '项目名称',calculExpr:'',addNewRowFlg: false},
          { field: 'comfullname', fieldtype: 'C', title: '供应商',calculExpr:'',addNewRowFlg: false},
          // { field: 'prsbjbegtime', fieldtype: 'C', title: '竞价开始时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']},
          // { field: 'prsbjendtime', fieldtype: 'C', title: '竞价截止时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']},
          { field: 'psubzjreturnusername', fieldtype: 'C', title: '退回确认人',calculExpr:'',addNewRowFlg: false},
          { field: 'psubzjreturntime', fieldtype: 'C', title: '退回时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']},
          { field: 'psubzjreturnflgCN', fieldtype: 'C', title: '状态',calculExpr:'',addNewRowFlg: false}
        ],
        psu: {},
        query: {
          comid: this.$store.getters.loginUser.comid,
          comtype: this.$store.getters.loginUser.comtype,
          userid: this.$store.getters.loginUser.userid,
          total: 0,
          limit: 20,
          offset: 0
        },
        projectStatusList:[]
      }
    },
    created () {
      this.$on('THBZJ', () => this.chgReturnBZJ())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.init()
      this.getPageList()
      this.getProjectStatusList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.psu = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async init() {
        this.query = {
          comid: this.$store.getters.loginUser.comid,
          comtype: this.$store.getters.loginUser.cositemcomtype,
          userid:this.$store.getters.loginUser.userid,
          limit: 20,
          offset: 0
          }
        this.list = []
        this.btnLoading = false
        this.psu = {}
      },
      async getProjectStatusList () {
        this.projectStatusList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'psubzjreturnflg'}
        })
      },
      async viewProject(row) {
        this.psu = row.row
        this.$router.push({name: 'psuBzjReturnForm', params: {form: this.psu,innerbtn: this.btn.inner, type: 3}})
      },
      async chgReturnBZJ () {
        if (!this.psu.psuid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        this.$router.push({name: 'psuBzjReturnForm', params: {form: this.psu, type: 1}})
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async cellClick (row) {
        this.psu = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getPageList () {
        this.loading = true

        this.query.status1 = 60
        this.query.status2 = 70

        let res = await request({
          method: 'get',
          url: '/xmgl/project/getBzjreturnIndexList',
          params: this.query
        })
        res.list.forEach((key)=>{
            if(key.psubzjreturnflg === 0){
                key.psubzjreturnflgCN = '未退回'
            }
            else{
                key.psubzjreturnflgCN = '已退回'
                key.psubzjreturntime = utils.formatterDate(key.psubzjreturntime,'yyyy-MM-dd HH:mm:ss')
            }
        })

        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
